import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";
import template from "./sw-banner.mjs";

export class SwBanner extends HTMLElement {
    private componentTrace: PerformanceTrace;
    private timer: number = 0;
    private banner: HTMLElement;
    private info: HTMLElement;
    private buddha: HTMLPictureElement;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-banner");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.banner = this.querySelector("#sw-banner")!;
        this.info = this.querySelector("#sw-banner-info")!;
        this.buddha = this.querySelector("picture")!;
    }

    connectedCallback() {
        this.addEventListener("click", (event: Event) => this.hideBanner(0));

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    showBanner(info: string, reload: boolean = false) {
        this.info.textContent = info;
        if (window.location.hash === "#ai")
            this.buddha.classList.remove("hidden");
        else this.buddha.classList.add("hidden");

        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => {
            this.banner.classList.remove("-translate-y-full");
            this.hideBanner(10000, reload);
        }, 500);
    }

    private hideBanner(duration: number, reload: boolean = false) {
        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => {
            if (reload) {
                window.location.reload();
            } else {
                this.banner.classList.add("-translate-y-full");
            }
        }, duration);
        logEvent(analytics, "close", { banner: "top" });
    }
}
